'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = require('./store');

/**
 * model请求缓存部分处理
 * Created by spring on 2018/9/5.
 */

// 直接量处理js自定义事件
var eventTarget = {
  // 保存事件类型，处理函数数组映射
  handlers: new _store.Store('eventHandlers'),

  // 注册给定类型的事件处理程序，
  // type -> 自定义事件类型， handler -> 自定义事件回调函数
  on: function on(type, handler) {
    // 判断事件处理数组是否有该类型事件
    if (eventTarget.handlers.get(type) === undefined) {
      eventTarget.handlers.set(type, []);
    }
    // 将处理事件push到事件处理数组里面
    eventTarget.handlers.get(type).push(handler);
  },


  // 触发一个事件
  // event -> 为一个js对象，属性中至少包含type属性，
  // 因为类型是必须的，其次可以传一些处理函数需要的其他变量参数。（这也是为什么要传js对象的原因）
  emit: function emit(event) {
    // 判断是否存在该事件类型
    if (eventTarget.handlers[event.type] instanceof Array) {
      var handler = eventTarget.handlers[event.type];
      // 在同一个事件类型下的可能存在多种处理事件，找出本次需要处理的事件
      for (var i = 0; i < handler.length; i++) {
        // 执行触发
        handler[i](event);
      }
      eventTarget.handlers[event.type] = []; // 清空事件
    }
  },


  // 注销事件
  // type -> 自定义事件类型， handler -> 自定义事件回调函数
  remove: function remove(type, handler) {
    var tmpHandler = eventTarget.handlers.get(type);
    if (tmpHandler instanceof Array) {
      // 在同一个事件类型下的可能存在多种处理事件，找出本次需要处理的事件
      for (var i = 0; i < tmpHandler.length; i++) {
        // 找出本次需要处理的事件下标
        if (tmpHandler[i] === handler) {
          // 删除处理事件
          tmpHandler.splice(i, 1);
          break;
        }
      }
    }
  }
};

exports.default = eventTarget;